import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { type Page, Pages } from '@/src/config/pages';
import { logger } from '@/src/internal/logger';
import { isPath } from '@/src/lib/urls';

/**
 * A hook that returns the active page, {@link Page}, for a given pathname, {@link string}.
 */
export const useActivePages = (): Page[] => {
  const { asPath } = useRouter();

  return useMemo(() => {
    if (!isPath(asPath)) {
      logger.error(`Detected an invalid 'asPath': '${asPath}', from the NextJS router!`);
      return [];
    }
    return Pages.getActivePages(asPath);
  }, [asPath]);
};
